// extracted by mini-css-extract-plugin
module.exports = {"container":"ShareSheetPopup_container__9zh1Z","openStyle":"ShareSheetPopup_openStyle__zR3u5","closeStyle":"ShareSheetPopup_closeStyle__B16Fz"};